import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Alert, Badge } from 'react-bootstrap';

/**
 * Org Admin > Online Store > "Ready to announce?": what the store still needs, ticked from what the organization already has. Required steps (a warehouse, a way to pay, a
 * published product...) are what stop it taking orders; the others are what buyers, and India's e-commerce rules, expect to see. Hides itself once everything is done.
 */
export default function StoreReadiness({ refreshKey }) {
  const [data, setData] = useState(null);
  const load = useCallback(async () => {
    try { setData((await axios.get('/api/store/readiness')).data); } catch (e) { setData(null); }
  }, []);
  useEffect(() => { load(); }, [load, refreshKey]);

  if (!data || data.toDo === 0) return null;
  const todo = data.steps.filter((s) => !s.done);
  return (
    <Alert variant={data.ready ? 'info' : 'warning'} className="mt-3" style={{ maxWidth: 820 }} data-testid="store-readiness">
      <div className="fw-semibold mb-1">{data.ready ? 'Your store can take orders. A few things would make it better before you announce it:' : 'Before you announce your store:'}</div>
      <ul className="mb-0 ps-3">
        {todo.map((s) => (
          <li key={s.key} data-testid={`readiness-${s.key}`}>
            {s.label} {s.required ? <Badge bg="danger" className="ms-1">needed</Badge> : <Badge bg="secondary" className="ms-1">recommended</Badge>}
            <div className="small text-muted">{s.hint}</div>
          </li>
        ))}
      </ul>
    </Alert>
  );
}
